import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import { sessionOperations } from '../../redux/ducks/session';
import accountRerouteUtil from '../../utils/accountRerouteUtil';

const PARTY_KEY = Math.random() + '_withAuthentication';

const withAuthentication = (WrappedComponent, isAccountComponent = true) => {
    return (props) => {
        const dispatch = useDispatch();
        const navigate = useNavigate();
        const location = useLocation();
        const authenticated = useSelector(({session}) => session.sessionState.authenticated);
        const loadingState = useSelector(({session}) => session.loadingState);

        useEffect(() => {
            // If we're not loading, and have loaded, handle our logged in state
            // If we're not loading, and have not loaded, check logged in status
            const isLoading = loadingState.partiesLoading.includes(PARTY_KEY);
            const hasLoaded = loadingState.partiesHaveLoaded.includes(PARTY_KEY);
            if (!isLoading && hasLoaded) {
                handleLoggedInState(authenticated, location);
            } else if (!isLoading && !hasLoaded) {
                dispatch(sessionOperations.fetchUserLoggedInStatus(PARTY_KEY));
                ;
            }
        }, [loadingState]);

        const handleLoggedInState = (isLoggedIn, location) => {
            if (!isLoggedIn) {
                const returnUrlQueryParam = 'returnUrl=' + encodeURIComponent(location.pathname + location.search);

                if (isAccountComponent) {
                    navigate('/?' + returnUrlQueryParam, { replace: true });
                } else {
                    window.location.href = '/account/ui?' + returnUrlQueryParam;
                }
            } else {
                if (isAccountComponent) {
                    accountRerouteUtil.attemptRerouting(location, navigate);
                }
            }
        };

        if (!authenticated) {
            return <span/>;
        }

        return <WrappedComponent {...props} />
    };
};

export default withAuthentication;
